module.exports = __webpack_public_path__ + "img/logo-2inventario-min.39db6aec.png";